module.exports = __webpack_public_path__ + "static/img/5.7e2c58d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/5.png
// module id = Gu+m
// module chunks = 0